/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { MdOutlineNavigateNext } from "react-icons/md";
import { useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  Breadcrumb,
  BreadcrumbItem,
  Button,
  Container,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import { IoIosSearch } from "react-icons/io";
import NoDataFound from "../../components/NoDataFound/NoDataFound";
// import HomeTopPlaces from "../../components/TopPlaces/HomeTopPlaces";
import { getSearchEverywhere } from "../../services/search.service";
// import { AiOutlineStar, AiFillStar } from "react-icons/ai";
// import { FiBriefcase } from "react-icons/fi";
import ".././Category/Cemetery/Cemetery.scss";
import "../Category/Cemetery/Cemetery.scss";
import swal from "sweetalert";
import {
  addUserFavorite,
  removeUserFavorite,
} from "../../services/favourites.service";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import SelectRouteModal from "../../components/Modals/SelectRouteModal";
import { routeDetail, updateRouteDetail } from "../../services/myRoute.service";
import CreateNewRouteModal from "../../components/Modals/CreateNewRouteModal";
import PointsListingModal from "../../components/Modals/PointsListingModal";
// import { BiExitFullscreen } from "react-icons/bi";
import ShareModal from "../../components/Modals/ShareModal";
// import { FiShare2 } from "react-icons/fi";
import { hideLoader, showLoader } from "../../utils/action/Action";
import { useDispatch } from "react-redux";
import { FaPlus } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import { IoHeartOutline, IoHeartSharp, IoShareSocial } from "react-icons/io5";
// import { HiDotsVertical } from "react-icons/hi";
import image_card from "../../assets/card_image.png";
import { GoHome } from "react-icons/go";
import ContainerLayout from "../../layout/ContainerLayout";
import fav_image from "../../assets/marked_pop.svg";
import { HiDotsVertical } from "react-icons/hi";
import ReportSuggestionModal from "../../components/Modals/ReportSuggestionModal";
import { API_URL } from "../../config/config";

export default function SearchEverywhere({ isUserLoggedIn }) {
  const [selecteData, setSelectData] = useState([]);
  const [route, setRoute] = useState(null);
  const [mkmID, setMkmId] = useState();
  const [showModal, setShowModal] = useState(false);
  const [showCreateRouteModal, setShowCreateRouteModal] = useState(false);
  const [showListModal, setShowListModal] = useState(false);
  const [routeName, setRouteName] = useState(null);
  const [title, setTitle] = useState("");
  const [link, setLink] = useState("");
  const [showShareModal, setShowShareModal] = useState(false);
  const [pointName, setPointName] = useState(null);
  const [showSpinner, setShowSpinner] = useState(false);
  const [dropdownMenuOpen, setMenuOpen] = useState();
  const [showReportModal, setShowReportModal] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userName = useSelector(
    (state) => state?.userDetailReducer?.userData?.userName
  );

  const toggle = () => {
    setShowModal(!showModal);
    setRoute(null);
  };

  useEffect(async () => {
    getSearchData();
  }, [location?.state]);

  const getSearchData = async () => {
    dispatch(showLoader());
    let obj = {
      filter: location?.state?.data.trim(),
      email: userName,
      checkForFavorite: true,
    };
    await getSearchEverywhere(obj).then((res) => {
      if (res?.status === 200) {
        switch (location?.state?.key) {
          case "cemeteriesCount":
            setSelectData(res?.data?.data["cemeteries"]);
            setTitle("Cemeteries/בית החיים");
            break;
          case "synagoguesCount":
            setSelectData(res?.data?.data["synagogues"]);
            setTitle("Synagogues/בית המדרש");
            break;
          case "motelsCount":
            setSelectData(res?.data?.data["motels"]);
            setTitle("Hotels/אכסניא");
            break;
          case "foodCount":
            setSelectData(res?.data?.data["food"]);
            setTitle("Food/מזון");
            break;
          case "mikvahCount":
            setSelectData(res?.data?.data["mikvah"]);
            setTitle("Mikvah/מקוה");
            break;
          case "historicalCount":
            setSelectData(res?.data?.data["historical"]);
            setTitle("Historical Places/היסטאריע");
            break;
          case "airportsCount":
            setSelectData(res?.data?.data["airports"]);
            setTitle("Airports/עירפארט");
            break;
          case "tzadikimCount":
            setSelectData(res?.data?.data["tzadikim"]);
            setTitle("Tzadikim/צדיקים");
            break;
          case "searcheverywhere":
            setSelectData(res?.data?.data);
            break;
          default:
            return "";
        }
      }
      dispatch(hideLoader());
    });
  };

  const handleSearch = (e) => {
    e.preventDefault();
    // refrsh data before search
    let search = e.target.value;
    let serchResult = [];
    if (search) {
      let obj = {
        filter: search.trim(),
        email: userName,
        checkForFavorite: true,
      };
      getSearchEverywhere(obj).then((res) => {
        if (res?.status === 200) {
          switch (location?.state?.key) {
            case "cemeteriesCount":
              serchResult = res?.data?.data["cemeteries"];
              break;
            case "synagoguesCount":
              serchResult = res?.data?.data["synagogues"];
              break;
            case "motelsCount":
              serchResult = res?.data?.data["motels"];
              break;
            case "foodCount":
              serchResult = res?.data?.data["food"];
              break;
            case "mikvahCount":
              serchResult = res?.data?.data["mikvah"];
              break;
            case "historicalCount":
              serchResult = res?.data?.data["historical"];
              break;
            case "airportsCount":
              serchResult = res?.data?.data["airports"];
              break;
            case "tzadikimCount":
              serchResult = res?.data?.data["tzadikim"];
              break;
            case "searcheverywhere":
              serchResult = res?.data?.data;
              break;
            default:
              return "";
          }
          setSelectData(serchResult);
        }
      });
    }
  };

  const addToFavorite = async (id, fav) => {
    if (isUserLoggedIn) {
      const willFavorite = await swal({
        title: "Are you sure?",
        text: "You want to add this route in Favorites Arjun?",
        icon: fav_image,
        buttons: true,
      });
      if (willFavorite) {
        try {
          const obj = {
            userName: userName,
          };
          const data = {
            mkmId:
              location?.state?.key === "tzadikimCount" || fav === "tzadikim"
                ? null
                : id,
            tzId:
              location?.state?.key === "tzadikimCount" || fav === "tzadikim"
                ? id
                : null,
          };
          const response = await addUserFavorite(data, obj);
          if (response && response?.status === 200) {
            swal(
              "Added!",
              "Your route has been added in Favorites!",
              "success"
            );
            getSearchData();
          }
        } catch (error) {
          toast.error(
            error?.response?.data?.message ||
              "Oops.. something went wrong, try again !!!",
            {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 2000,
            }
          );
        }
      }
    } else {
      const notLoggedIn = await swal({
        title: "Please Continue to Log In",
        text: "You want to add this route in Favorites?",
        icon: { fav_image },
        buttons: ["Cancel", "Log In"],
      });
      if (notLoggedIn) {
        navigate("/sign-in");
      }
    }
  };

  const removeFromFavorite = async (id, fav) => {
    if (isUserLoggedIn) {
      const willRemoveFavorite = await swal({
        title: "Are you sure?",
        text: "You want to remove this route from Favorites?",
        icon: fav_image,
        buttons: true,
      });
      if (willRemoveFavorite) {
        try {
          const obj = {
            userName: userName,
          };
          const data = {
            mkmId:
              location?.state?.key === "tzadikimCount" || fav === "tzadikim"
                ? null
                : id,
            tzId:
              location?.state?.key === "tzadikimCount" || fav === "tzadikim"
                ? id
                : null,
          };
          const response = await removeUserFavorite(data, obj);
          if (response && response?.status === 200) {
            swal(
              "Removed!",
              "Your route has been removed from Favorites!",
              "success"
            );
            getSearchData();
          }
        } catch (error) {
          toast.error(
            error?.response?.data?.message ||
              "Oops.. something went wrong, try again !!!",
            {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 2000,
            }
          );
        }
      }
    } else {
      const notLoggedIn = await swal({
        title: "Please Continue to Log In",
        text: "You want to remove this route from Favorites?",
        icon: "warning",
        buttons: ["Cancel", "Log In"],
      });
      if (notLoggedIn) {
        navigate("/sign-in");
      }
    }
  };

  const reportSuggestion = (title, id) => {
    setMkmId(id);
    setPointName(title);
    setShowReportModal(true);
  };
  const selectRoute = async () => {
    let existingData;
    try {
      let response = await routeDetail({
        userName: userName,
        routeID: route?.id,
      });
      if (response && response?.status === 200) {
        existingData = response?.data?.data;
      }

      let requestBody = [];
      if (existingData?.length < 25) {
        if (existingData?.length === 0) {
          requestBody?.push({
            mkmID: mkmID,
            orderNumber: 0,
            visited: false,
          });
        } else if (existingData?.length === 1) {
          requestBody?.push({
            mkmID: existingData[0]?.place?.mkmID,
            orderNumber: 0,
            visited: false,
          });
          requestBody?.push({
            mkmID: mkmID,
            orderNumber: 1,
            visited: false,
          });
        } else {
          existingData?.splice(existingData?.length, 0, {
            mkmID: mkmID,
            orderNumber: existingData?.length,
            visited: false,
          });
          requestBody = existingData?.map((item, i) => {
            return {
              mkmID: item?.place?.mkmID || item?.mkmID,
              orderNumber: i,
              visited: item?.visited,
            };
          });
        }
        try {
          setShowSpinner(true);
          let res = await updateRouteDetail(requestBody, {
            userName: userName,
            routeID: route?.id,
          });
          if (res && res?.status === 200) {
            toast.success("Point Added Successfully In Your Route!", {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 2000,
            });
            setShowSpinner(false);
          }
        } catch (err) {
          toast.error(
            err?.response?.data?.message ||
              "Oops.. something went wrong, try again !!!",
            {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 2000,
            }
          );
          setShowSpinner(false);
        }
        setRoute("");
        setShowModal(false);
      } else {
        toast.warning(
          "Max of only 25 points can be added to a route, Kindly remove a point to add a new point.",
          {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          }
        );
        setShowSpinner(false);
      }
    } catch (err) {
      console.log(err);
      setShowSpinner(false);
    }
  };

  const createNewRoute = () => {
    setShowModal(false);
    setShowCreateRouteModal(true);
  };

  const addToRoute = (id, item) => {
    setMkmId(id);
    setPointName(item);
    setShowModal(true);
  };

  const share = (name) => {
    var data;
    if (name === "Tzadikim") {
      data = `${window?.location?.protocol}//${window?.location?.host}/search-everywhere`;
      setLink(data);
    } else {
      data = `${window?.location?.protocol}//${window?.location?.host}/search-everywhere`;
      setLink(data);
    }
    setShowShareModal(true);
  };

  return (
    <>
      <ShareModal
        showShareModal={showShareModal}
        setShowShareModal={setShowShareModal}
        link={link}
        setLink={setLink}
      />
      <SelectRouteModal
        route={route}
        setRoute={setRoute}
        showModal={showModal}
        toggle={toggle}
        createNewRoute={createNewRoute}
        selectRoute={selectRoute}
        showSpinner={showSpinner}
      />
      <CreateNewRouteModal
        showCreateRouteModal={showCreateRouteModal}
        setShowCreateRouteModal={setShowCreateRouteModal}
        showListModal={showListModal}
        setShowListModal={setShowListModal}
        routeName={routeName}
        setRouteName={setRouteName}
        pointName={pointName}
        setPointName={setPointName}
      />
      <PointsListingModal
        showListModal={showListModal}
        setShowListModal={setShowListModal}
        setRouteName={setRouteName}
        routeName={routeName}
        pointName={pointName}
        setPointName={setPointName}
      />

      <ReportSuggestionModal
        showReportModal={showReportModal}
        setShowReportModal={setShowReportModal}
        showListModal={showListModal}
        setShowListModal={setShowListModal}
        setRouteName={setRouteName}
        routeName={routeName}
        pointName={pointName}
        mkmID={mkmID}
      />
      {/* <SearchBar /> */}
      <div className="main_section cemetery">
        <div className="breadcrumb_section">
          <Container>
            <Breadcrumb className="nt-breadcrumb">
              <BreadcrumbItem>
                <Link to="/" className="breadcrumb_item1">
                  <GoHome className="home_icon" />
                </Link>
                <span className="breadcrumb-divider">
                  <MdOutlineNavigateNext />
                </span>
              </BreadcrumbItem>
              <BreadcrumbItem>
                <Link
                  to="/search-everywhere"
                  state={{
                    data: location?.state?.data,
                    key: location?.state?.key,
                  }}
                  className="nt-breadcrumb_item2"
                >
                  Categories
                </Link>
              </BreadcrumbItem>
            </Breadcrumb>
          </Container>
        </div>
        {/* <HomeTopPlaces /> */}
        {location?.state?.key === "searcheverywhere" ? (
          selecteData?.length === 0 ? (
            <NoDataFound />
          ) : (
            Object.entries(selecteData)?.map((item, index) =>
              item?.length !== 0 ? (
                // console.log("dgfgdfgsfgfd" ,selecteData.typeof);

                <div className="myroutes_section">
                  <ContainerLayout classes={{ maxWidth: "1300px" }}>
                    <div className="myroutes_box" key={index}>
                      <div className="myroutes_heading">
                        <h4>{item[0]}</h4>
                      </div>
                      <div className="header_bottom">
                        <div
                          className="left_side"
                          style={{ marginInline: "auto" }}
                        >
                          <div className="search_input">
                            <IoIosSearch className="icon" />
                            <input
                              type="text"
                              id="search"
                              name="search"
                              placeholder={`Search`}
                              // value={values?.search}
                              onChange={handleSearch}
                              maxLength="100"
                              autoComplete="off"
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        className={`item_card ${
                          item[1].length <= 2 ? "two-items" : ""
                        }`}
                      >
                        {selecteData?.length === 0 ||
                        selecteData === undefined ? (
                          <NoDataFound />
                        ) : (
                          item[1]?.map((place, index) => (
                            <div className="grid_card" key={index}>
                              <Link
                                to={`/category-detail/${
                                  location?.state?.key === "tzadikimCount"
                                    ? "?tzadikimId=" + place?.tzadikimID
                                    : "?MkmId=" + place?.mkmID
                                }&cor=${place?.poi}`}
                                state={{
                                  from: "searchEverywhere",
                                  searchCategoryName: title?.split("/")[0],
                                  data: location?.state?.data,
                                  key: location?.state?.key,
                                }}
                              >
                                <div className="card_items">
                                  {" "}
                                  <div className="card_image">
                                    {/* <img src={image_card} alt="placeholder" /> */}
                                    <img
                                      src={
                                        place?.imageIDs?.length > 0
                                          ? `${API_URL}/api/mkm/getimage/${place?.imageIDs?.[0]}`
                                          : image_card
                                      }
                                      alt="placeholder"
                                    />
                                  </div>
                                  <div className="like_list">
                                    <div className="like_icon">
                                      {place?.userFavorite === true ? (
                                        <div
                                          style={{ color: "#F57D2B" }}
                                          onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            removeFromFavorite(
                                              location?.state?.key ===
                                                "tzadikimCount"
                                                ? place?.tzadikimID
                                                : place?.mkmID
                                            );
                                          }}
                                        >
                                          {" "}
                                          <IoHeartSharp size="22px" />
                                        </div>
                                      ) : (
                                        <div
                                          style={{ color: "#787776" }}
                                          onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            addToFavorite(
                                              location?.state?.key ===
                                                "tzadikimCount"
                                                ? place?.tzadikimID
                                                : place?.mkmID
                                            );
                                          }}
                                        >
                                          {" "}
                                          <IoHeartOutline size="22px" />
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                  <div className="dropdown_list">
                                    <Dropdown
                                      className="moreInfo"
                                      toggle={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        setMenuOpen(
                                          index === dropdownMenuOpen
                                            ? null
                                            : index
                                        );
                                      }}
                                      isOpen={index === dropdownMenuOpen}
                                    >
                                      <DropdownToggle
                                        className="list_icon"
                                        caret={false}
                                      >
                                        <HiDotsVertical className="list" />
                                      </DropdownToggle>

                                      <DropdownMenu
                                        className="custom_dropdown"
                                        modifiers={[
                                          {
                                            name: "offset",
                                            options: {
                                              offset: [-140, 5],
                                            },
                                          },
                                        ]}
                                      >
                                        <DropdownItem>
                                          <Link
                                            to={`/along-the-way-to-here/${place?.poi}`}
                                            state={{
                                              categoryName:
                                                title?.split("/")[0],
                                              categoryTitle:
                                                place?.categoryTitle,
                                              categoryIcon: place?.categoryIcon,
                                            }}
                                            className="breadcrumb_item1"
                                          >
                                            Along the way to here
                                          </Link>
                                        </DropdownItem>
                                        <DropdownItem
                                          onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            reportSuggestion(
                                              place?.title,
                                              place?.tzadikimID
                                                ? place?.tzadikimID
                                                : place?.mkmID
                                            );
                                          }}
                                        >
                                          Report suggestion
                                        </DropdownItem>
                                      </DropdownMenu>
                                    </Dropdown>
                                  </div>
                                  <div className="card_top">
                                    <div
                                      className="left_section"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        share(title);
                                      }}
                                    >
                                      <IoShareSocial />
                                    </div>
                                    <div className="right_section">
                                      <Link
                                        to={`/category-detail/${
                                          location?.state?.key ===
                                          "tzadikimCount"
                                            ? "?tzadikimId=" + place?.tzadikimID
                                            : "?MkmId=" + place?.mkmID
                                        }&cor=${place?.poi}`}
                                        state={{
                                          from: "searchEverywhere",
                                          searchCategoryName:
                                            title?.split("/")[0],
                                          data: location?.state?.data,
                                          key: location?.state?.key,
                                        }}
                                      >
                                        <h3
                                          className="card_title"
                                          title={place?.title}
                                        >
                                          {place?.title}
                                        </h3>
                                      </Link>
                                      <h4>
                                        {" "}
                                        {place?.cityY
                                          ? place?.cityY.substring(
                                              place?.cityY.indexOf("/") + 1
                                            )
                                          : null}
                                        {place?.stateY
                                          ? " - " +
                                            place?.stateY.substring(
                                              place?.stateY.indexOf("/") + 1
                                            )
                                          : null}
                                      </h4>
                                    </div>
                                  </div>
                                  <div className="card_location">
                                    <div className="location_icon">
                                      <FaLocationDot />
                                    </div>
                                    <div className="place_name">
                                      {place?.cityE + " " + place?.stateE}
                                    </div>
                                  </div>
                                  <div className="card_buttons">
                                    <Button
                                      className="btn_explore"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                      }}
                                    >
                                      <Link
                                        style={{ color: "#F57D2B" }}
                                        to={`/explore-near-by/${place?.poi}`}
                                        state={{
                                          from: "searchEverywhere",
                                          searchCategoryName:
                                            title?.split("/")[0],
                                          data: location?.state?.data,
                                          key: location?.state?.key,
                                        }}
                                      >
                                        {" "}
                                        Explore Near By
                                      </Link>
                                    </Button>
                                    <Link
                                      className="btns_viewmore"
                                      to={`/category-detail/${
                                        location?.state?.key === "tzadikimCount"
                                          ? "?tzadikimId=" + place?.tzadikimID
                                          : "?MkmId=" + place?.mkmID
                                      }&cor=${place?.poi}`}
                                      state={{
                                        from: "searchEverywhere",
                                        searchCategoryName:
                                          title?.split("/")[0],
                                        categoryName: title?.split("/")[0],
                                        data: location?.state?.data,
                                        key: location?.state?.key,
                                      }}
                                    >
                                      View More
                                    </Link>
                                    <Button
                                      className="btn_addroute"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        addToRoute(place?.mkmID, place);
                                      }}
                                    >
                                      <FaPlus className="addroute_icon" />
                                      Add to Route
                                    </Button>
                                  </div>
                                </div>
                              </Link>
                            </div>
                          ))
                        )}
                      </div>
                      {/* <Row>
                        {item[1]?.map((place, index) => (
                          <Col xxl="4" lg="6" md="12" key={index}>
                            <Card body>
                              <div className="card_header">
                                {place?.userFavorite === true ? (
                                  <Button
                                    className="favourite_fill_icon"
                                    onClick={() =>
                                      removeFromFavorite(
                                        item[0] === "tzadikim"
                                          ? place?.tzadikimID
                                          : place?.mkmID,
                                        item[0]
                                      )
                                    }
                                  >
                                    <AiFillStar size={20} />
                                  </Button>
                                ) : (
                                  <Button
                                    className="favourite_icon"
                                    onClick={() =>
                                      addToFavorite(
                                        item[0] === "tzadikim"
                                          ? place?.tzadikimID
                                          : place?.mkmID,
                                        item[0]
                                      )
                                    }
                                  >
                                    <AiOutlineStar size={20} />
                                  </Button>
                                )}
                                <div className="right_section">
                                  <Link
                                    to={`/category-detail/${
                                      item[0] === "tzadikim"
                                        ? "?tzadikimId=" + place?.tzadikimID
                                        : "?MkmId=" + place?.mkmID
                                    }&cor=${place?.poi}`}
                                    state={{
                                      from: "searchEverywhere",
                                      searchCategoryName: item[0],
                                      data: location?.state?.data,
                                      key: location?.state?.key,
                                    }}
                                    tag="h5"
                                    title={place?.title}
                                    className="card_link"
                                  >
                                    {place?.title}
                                  </Link>
                                  <div className="moreInfo" />
                                </div>
                              </div>
                              <CardText className="grid_text_le">
                                {place?.cityY
                                  ? place?.cityY.substring(
                                      place?.cityY.indexOf("/") + 1
                                    )
                                  : null}
                                {place?.stateY
                                  ? " - " +
                                    place?.stateY.substring(
                                      place?.stateY.indexOf("/") + 1
                                    )
                                  : null}
                              </CardText>
                              <div className="card_bottom">
                                <Button onClick={() => share(item[0])}>
                                  <FiShare2 size={20} />
                                </Button>
                                <div className="right_section">
                                  <CardText>
                                    {place?.cityE + " " + place?.stateE}
                                  </CardText>
                                  <MdLocationOn
                                    className="location_icon"
                                    size={18}
                                  />
                                </div>
                              </div>
                              <div className="card_footer">
                                <Link
                                  to={`/explore-near-by/${place?.poi}`}
                                  state={{
                                    from: "searchEverywhere",
                                    searchCategoryName: item[0],
                                    data: location?.state?.data,
                                    key: location?.state?.key,
                                  }}
                                  className="btn explore"
                                >
                                  <BiExitFullscreen className="explore_icon" />
                                  Explore Near By
                                </Link>
                                <Link
                                  to={`/category-detail/${
                                    item[0] === "tzadikim"
                                      ? "?tzadikimId=" + place?.tzadikimID
                                      : "?MkmId=" + place?.mkmID
                                  }&cor=${place?.poi}`}
                                  state={{
                                    from: "searchEverywhere",
                                    searchCategoryName: item[0],
                                    data: location?.state?.data,
                                    key: location?.state?.key,
                                  }}
                                  className="btn viewmore"
                                >
                                  View More
                                </Link>
                                <Button
                                  className="btn addroute"
                                  onClick={() =>
                                    addToRoute(place?.mkmID, place)
                                  }
                                >
                                  <FiBriefcase className="addroute_icon" />
                                  Add to Route
                                </Button>
                              </div>
                            </Card>
                          </Col>
                        ))}
                      </Row> */}
                    </div>
                  </ContainerLayout>
                </div>
              ) : (
                ""
              )
            )
          )
        ) : (
          <div className="myroutes_section">
            {/* <div className="searcheve_section_header">
                    <h4>{title} </h4>
                    <div className="search_input">
                      <InputGroup size="sm">
                        <InputGroupText style={{ backgroundColor: "#FFFFFF" }}>
                          <IoIosSearch size={25} />
                        </InputGroupText>
                        <Input
                          type="search"
                          id="search"
                          name="search"
                          maxLength="100"
                          placeholder="Search"
                          autoComplete="off"
                          onChange={handleSearch}
                        />
                      </InputGroup>
                    </div>
                  </div> */}
            <ContainerLayout classes={{ maxWidth: "1300px" }}>
              <div className="myroutes_box">
                <div className="myroutes_heading">
                  <h4>{title} </h4>
                </div>

                <div className="header_bottom">
                  <div className="left_side" style={{ marginInline: "auto" }}>
                    <div className="search_input">
                      <IoIosSearch className="icon" />
                      <input
                        type="text"
                        id="search"
                        name="search"
                        placeholder={`Search`}
                        // value={values?.search}
                        onChange={handleSearch}
                        maxLength="100"
                        autoComplete="off"
                      />
                    </div>
                  </div>
                </div>
                <div
                  className={`item_card ${
                    selecteData?.length <= 2 ? "two-items" : ""
                  }`}
                >
                  {selecteData?.length === 0 || selecteData === undefined ? (
                    <NoDataFound />
                  ) : (
                    selecteData?.map((place, index) => (
                      <div className="grid_card">
                        <div className="card_items" key={index}>
                          <Link
                            to={`/category-detail/${
                              location?.state?.key === "tzadikimCount"
                                ? "?tzadikimId=" + place?.tzadikimID
                                : "?MkmId=" + place?.mkmID
                            }&cor=${place?.poi}`}
                            state={{
                              from: "searchEverywhere",
                              searchCategoryName: title?.split("/")[0],
                              data: location?.state?.data,
                              key: location?.state?.key,
                            }}
                          >
                            <div className="card_items">
                              {" "}
                              <div className="card_image">
                                {/* <img src={image_card} alt="placeholder" /> */}
                                <img
                                  src={
                                    place?.imageIDs?.length > 0
                                      ? `${API_URL}/api/mkm/getimage/${place?.imageIDs?.[0]}`
                                      : image_card
                                  }
                                  alt="placeholder"
                                />
                              </div>
                              <div className="like_list">
                                <div className="like_icon">
                                  {place?.userFavorite === true ? (
                                    <div
                                      style={{ color: "#F57D2B" }}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        removeFromFavorite(
                                          location?.state?.key ===
                                            "tzadikimCount"
                                            ? place?.tzadikimID
                                            : place?.mkmID
                                        );
                                      }}
                                    >
                                      {" "}
                                      <IoHeartSharp size="22px" />
                                    </div>
                                  ) : (
                                    <div
                                      style={{ color: "#787776" }}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        addToFavorite(
                                          location?.state?.key ===
                                            "tzadikimCount"
                                            ? place?.tzadikimID
                                            : place?.mkmID
                                        );
                                      }}
                                    >
                                      {" "}
                                      <IoHeartOutline size="22px" />
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div className="dropdown_list">
                                <Dropdown
                                  className="moreInfo"
                                  toggle={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    setMenuOpen(
                                      index === dropdownMenuOpen ? null : index
                                    );
                                  }}
                                  isOpen={index === dropdownMenuOpen}
                                >
                                  <DropdownToggle
                                    className="list_icon"
                                    caret={false}
                                  >
                                    <HiDotsVertical className="list" />
                                  </DropdownToggle>

                                  <DropdownMenu
                                    className="custom_dropdown"
                                    modifiers={[
                                      {
                                        name: "offset",
                                        options: {
                                          offset: [-140, 5],
                                        },
                                      },
                                    ]}
                                  >
                                    <DropdownItem>
                                      <Link
                                        to={`/along-the-way-to-here/${place?.poi}`}
                                        state={{
                                          categoryName: title?.split("/")[0],
                                          categoryTitle: place?.categoryTitle,
                                          categoryIcon: place?.categoryIcon,
                                        }}
                                        className="breadcrumb_item1"
                                      >
                                        Along the way to here
                                      </Link>
                                    </DropdownItem>
                                    <DropdownItem
                                      onClick={() =>
                                        reportSuggestion(
                                          place?.title,
                                          place?.tzadikimID
                                            ? place?.tzadikimID
                                            : place?.mkmID
                                        )
                                      }
                                    >
                                      Report suggestion
                                    </DropdownItem>
                                  </DropdownMenu>
                                </Dropdown>
                              </div>
                              <div className="card_top">
                                <div
                                  className="left_section"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    share(title);
                                  }}
                                >
                                  <IoShareSocial />
                                </div>
                                <div className="right_section">
                                  <Link
                                    to={`/category-detail/${
                                      location?.state?.key === "tzadikimCount"
                                        ? "?tzadikimId=" + place?.tzadikimID
                                        : "?MkmId=" + place?.mkmID
                                    }&cor=${place?.poi}`}
                                    state={{
                                      from: "searchEverywhere",
                                      searchCategoryName: title?.split("/")[0],
                                      data: location?.state?.data,
                                      key: location?.state?.key,
                                    }}
                                  >
                                    <h3
                                      className="card_title"
                                      title={place?.title}
                                    >
                                      {place?.title}
                                    </h3>
                                  </Link>
                                  <h4>
                                    {" "}
                                    {place?.cityY
                                      ? place?.cityY.substring(
                                          place?.cityY.indexOf("/") + 1
                                        )
                                      : null}
                                    {place?.stateY
                                      ? " - " +
                                        place?.stateY.substring(
                                          place?.stateY.indexOf("/") + 1
                                        )
                                      : null}
                                  </h4>
                                </div>
                              </div>
                              <div className="card_location">
                                <div className="location_icon">
                                  <FaLocationDot />
                                </div>
                                <div className="place_name">
                                  {place?.cityE + " " + place?.stateE}
                                </div>
                              </div>
                              <div className="card_buttons">
                                <Button
                                  className="btn_explore"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                  }}
                                >
                                  <Link
                                    style={{ color: "#F57D2B" }}
                                    to={`/explore-near-by/${place?.poi}`}
                                    state={{
                                      from: "searchEverywhere",
                                      searchCategoryName: title?.split("/")[0],
                                      data: location?.state?.data,
                                      key: location?.state?.key,
                                    }}
                                  >
                                    {" "}
                                    Explore Near By
                                  </Link>
                                </Button>
                                <Link
                                  className="btns_viewmore"
                                  to={`/category-detail/${
                                    location?.state?.key === "tzadikimCount"
                                      ? "?tzadikimId=" + place?.tzadikimID
                                      : "?MkmId=" + place?.mkmID
                                  }&cor=${place?.poi}`}
                                  state={{
                                    from: "searchEverywhere",
                                    searchCategoryName: title?.split("/")[0],
                                    categoryName: title?.split("/")[0],
                                    data: location?.state?.data,
                                    key: location?.state?.key,
                                  }}
                                >
                                  View More
                                </Link>
                                <Button
                                  className="btn_addroute"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    addToRoute(place?.mkmID, place);
                                  }}
                                >
                                  <FaPlus className="addroute_icon" />
                                  Add to Route
                                </Button>
                              </div>
                            </div>
                          </Link>
                        </div>
                      </div>
                    ))
                  )}
                </div>

                {/* <Row>
                    {selecteData?.length === 0 ? (
                      <NoDataFound />
                    ) : (
                      selecteData?.map((place, index) => (
                        <Col xxl="4" lg="6" md="12" key={index}>
                          <Card body>
                            <div className="card_header">
                              {place?.userFavorite === true ? (
                                <Button
                                  className="favourite_fill_icon"
                                  onClick={() =>
                                    removeFromFavorite(
                                      location?.state?.key === "tzadikimCount"
                                        ? place?.tzadikimID
                                        : place?.mkmID
                                    )
                                  }
                                >
                                  <AiFillStar size={20} />
                                </Button>
                              ) : (
                                <Button
                                  className="favourite_icon"
                                  onClick={() =>
                                    addToFavorite(
                                      location?.state?.key === "tzadikimCount"
                                        ? place?.tzadikimID
                                        : place?.mkmID
                                    )
                                  }
                                >
                                  <AiOutlineStar size={20} />
                                </Button>
                              )}
                              <div className="right_section">
                                <Link
                                  to={`/category-detail/${
                                    location?.state?.key === "tzadikimCount"
                                      ? "?tzadikimId=" + place?.tzadikimID
                                      : "?MkmId=" + place?.mkmID
                                  }&cor=${place?.poi}`}
                                  state={{
                                    from: "searchEverywhere",
                                    searchCategoryName: title?.split("/")[0],
                                    data: location?.state?.data,
                                    key: location?.state?.key,
                                  }}
                                  tag="h5"
                                  title={place?.title}
                                  className="card_link"
                                >
                                  {place?.title}
                                </Link>
                              </div>
                            </div>
                            <CardText className="grid_text_le">
                              {place?.cityY
                                ? place?.cityY.substring(
                                    place?.cityY.indexOf("/") + 1
                                  )
                                : null}{" "}
                              {place?.stateY
                                ? " - " +
                                  place?.stateY.substring(
                                    place?.stateY.indexOf("/") + 1
                                  )
                                : null}
                            </CardText>
                            <div className="card_bottom">
                              <Button onClick={() => share(title)}>
                                <FiShare2 size={20} />
                              </Button>
                              <div className="right_section">
                                <CardText>
                                  {place?.cityE + " " + place?.stateE}
                                </CardText>
                                <MdLocationOn
                                  className="location_icon"
                                  size={18}
                                />
                              </div>
                            </div>
                            <div className="card_footer">
                              <Link
                                to={`/explore-near-by/${place?.poi}`}
                                state={{
                                  from: "searchEverywhere",
                                  searchCategoryName: title?.split("/")[0],
                                  data: location?.state?.data,
                                  key: location?.state?.key,
                                }}
                                className="btn explore"
                              >
                                <BiExitFullscreen className="explore_icon" />
                                Explore Near By
                              </Link>
                              <Link
                                to={`/category-detail/${
                                  location?.state?.key === "tzadikimCount"
                                    ? "?tzadikimId=" + place?.tzadikimID
                                    : "?MkmId=" + place?.mkmID
                                }&cor=${place?.poi}`}
                                state={{
                                  from: "searchEverywhere",
                                  searchCategoryName: title?.split("/")[0],
                                  categoryName: title?.split("/")[0],
                                  data: location?.state?.data,
                                  key: location?.state?.key,
                                }}
                                className="btn viewmore"
                              >
                                View More
                              </Link>
                              <Button
                                className="btn addroute"
                                onClick={() => addToRoute(place?.mkmID, place)}
                              >
                                <FiBriefcase className="addroute_icon" />
                                Add to Route
                              </Button>
                            </div>
                          </Card>
                        </Col>
                      ))
                    )}
                  </Row> */}
              </div>
            </ContainerLayout>
          </div>
        )}
      </div>
    </>
  );
}
